<template>
  <div class="section-main__warp inspection-wrap">
    <ioc-table ref="crud"
               v-model="plan"
               :data="tableData"
               :option="option"
               :page="page"
               @row-save="handleCreate"
               @row-update="handleUpdate"
               @row-cancle="closeDialog"
               @search-change="handleSearchChange"
               @search-reset="handleSearchReset"
               @size-change="handleSizeChange"
               @current-change="handleCurrentChange">
      <!-- 顶部按钮 自定义 -->
      <template slot="menuLeft">
        <el-button type="primary"
                   size="small"
                   class="iss-operation-button"
                   icon="el-icon-plus"
                   v-auth="'/assetinspection/assetsConfig:add'"
                   @click="handleAddAccount">
          {{ $t('workGroup.button.add') }}
        </el-button>
      </template>
      <!-- 表格按钮 自定义 -->
      <template slot="menu"
                slot-scope="scope">
        <el-tooltip class="item"
                    effect="dark"
                    content="删除"
                    placement="top"

                    popper-class="tooltip-draw">
          <el-button type="text"
                     icon="el-icon-delete"
                      v-auth="'/assetinspection/assetsConfig:delete'"
                     @click="handleDel(scope.row)"></el-button>
        </el-tooltip>
      </template>

    </ioc-table>
  </div>
</template>
<script>
import { api } from '../api'
import option from '../const/configOption'
import utils from '@src/common/utils'
import { Dic, Bus, Dates } from '$utils'
export default {
  components: {
  },
  data () {
    return {
      plan: {
        areaList: '',
      },
      tableData: [],
      checkedAssets: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      searchParams: {},
      option: option(),
      rowInfo: {},
      addGroupList: false,
      // areaName: '',
      fireassetType: '',
      patrolItemList: '',
      form: {
        areaList: [
          // {
          //   area: '',//区域编号
          //   areaName: '', //区域名称
          // }
        ],
        fireassetTypeList: [
          // {
          //   fireassetType: '',
          //   patrolItemList: []
          // }
        ],
        inspectPersonList: [],
        creator: '',
        startTime: '',
        endTime: '',
      },
      addShow: false,
      addTableData: [],
      assetsType: Dic.find('SENU077'),
      assetsTypeOption: Dic.find('SENU077'),
      assetsTypeExist: [],
      assetsTypeExistOption: [],
      // fireassetNameOption: Dic.find('SENU078'),
      fireassetNameOption: [],
      workGroup: [],
    }
  },
  mounted () {
    this.getList()
    this.queryWorkGroup()
  },
  created () { },
  computed: {
  },
  methods: {
    handleSearchReset () {
      this.getList()
    },
    getList () {
      const params = {
        // fireassetType: '',
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      }
      this.$fetch(api.inspectionPlan.queryPatrolItemConfig, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent)
          return
        } else {
          this.tableData = response.returnObj ? Object.freeze([...response.returnObj.list]) : []
          this.page.total = response.returnObj ? response.returnObj.total : 0
          this.$refs.crud.selectClear()
        }
      })
    },
    handleCurrentChange (val) {
      this.page.currentPage = val
      this.getList()
    },
    handleSizeChange (val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.getList()
    },
    handleSearchChange (param) {
      this.searchParams = param
      this.page.currentPage = 1
      this.getList()
    },
    handleAddAccount () {
      this.$refs.crud.rowAdd()
    },
    handleDel (row) {
      const params = {
        patrolItemCode: row.patrolItemCode, //'巡检计划code'
      }
      this.$confirm('您确定删除该巡检配置项吗?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$fetch(api.inspectionPlan.deletePatrolItemConfig, params).then((response) => {
          if (response && response.success) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error(response.msgContent)
          }
        })
      })
    },
    // 新建巡检任务
    handleCreate (addInfo, done) {
      this.$fetch(api.inspectionPlan.addPatrolItemConfig, addInfo).then((res) => {
        if (res && res.success) {
          this.getList()
          this.$message.success('新增成功')
          done()
        } else {
          this.$message.error(res.msgContent)
        }
      })
    }
  },
}
</script>
<style lang="scss">
</style>
